import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { tendersAPI } from '../services/api';
import { BookMarked, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Saved() {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    tendersAPI.saved().then(res => setTenders(res.data.items)).finally(() => setLoading(false));
  }, []);

  const handleUnsave = async (id, e) => {
    e.stopPropagation();
    try {
      await tendersAPI.save(id);
      setTenders(prev => prev.filter(t => t.id !== id));
      toast.success('Tender removed from saved list');
    } catch { toast.error('Failed to remove tender'); }
  };

  return (
    <div>
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontSize: '26px', marginBottom: '6px' }}>Saved Tenders</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>{tenders.length} saved tenders</p>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: 'var(--text-muted)' }}>Loading...</div>
      ) : tenders.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
          <BookMarked size={40} color="var(--text-muted)" style={{ marginBottom: '16px' }} />
          <h3 style={{ marginBottom: '8px' }}>No saved tenders yet</h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '24px' }}>
            Browse tenders and save the ones you want to track
          </p>
          <button className="btn btn-primary" onClick={() => navigate('/tenders')}>Browse Tenders</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {tenders.map(tender => (
            <div key={tender.id} className="card" style={{ cursor: 'pointer', borderLeft: '3px solid var(--accent-green)' }}
              onClick={() => navigate(`/tenders/${tender.id}`)}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    <span className={`badge badge-${tender.urgency}`}>{tender.days_remaining}d left</span>
                    <span className="badge badge-open">{tender.category}</span>
                  </div>
                  <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '4px' }}>{tender.title}</h3>
                  <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{tender.agency} • {tender.state}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginLeft: '16px' }}>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '16px', fontWeight: '700', color: 'var(--accent-green)' }}>{tender.contract_value_formatted}</div>
                  </div>
                  <button className="btn btn-ghost" style={{ padding: '6px 10px' }}
                    onClick={(e) => handleUnsave(tender.id, e)}>
                    <Trash2 size={14} color="var(--accent-red)" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
